export const UPDATE_GRID_VIEW = 'UPDATE_GRID_VIEW';
export const UPDATE_SAVED_VIEW = 'UPDATE_SAVED_VIEW';
export const CLEAR_GRIDS = 'CLEAR_GRIDS';
